var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"user-link",attrs:{"to":{ name: 'Profile', params: { id: _vm.user.id } }}},[_c('v-avatar',{staticClass:"mr-1",attrs:{"size":"32px"}},[_c('v-img',{attrs:{"src":_setup.getImageById(_vm.user.avatar, 32, 32, 'avatar')}})],1),_vm._v(" "+_vm._s(_vm.user.dancerName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }